import React from 'react';
import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function ErrorModal(props) {
    useTranslationSubscription();
    const handleCloseDialog = (event, reason) => {
        if (event && reason === "backdropClick") {
            return false;
        }
        props.handleCloseDialog();
    }

    return (
        <Dialog
            open={props.open}
            onClose={(event, reason) => handleCloseDialog(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {props.message}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={props.handleCloseDialog}
                >
                    {trI18n('COMBTN004')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ErrorModal;
